import React from 'react'

// core components
import IndexNavbar from 'components/Navbars/IndexNavbar'
import IndexHeader from 'components/Headers/IndexHeader'
import Footer from 'components/Footers/Footer'

// index sections
import SectionRegister from 'views/index-sections/SectionRegister'
import Sections from 'views/index-sections/Sections'

const Index = ({ location }) => {
  const searchParams = new URLSearchParams(location.search)
  const utmSource = searchParams.has('utm_source') ? searchParams.get('utm_source') : ''

  return (
    <>
      <IndexNavbar />
      <IndexHeader />
      <div className="main">
        <SectionRegister utmSource={utmSource} />
        <Sections />
        <Footer />
      </div>
    </>
  )
}

export default Index
